import { forwardRef, type InputHTMLAttributes } from "react";
import { cx } from "@/shared/lib/cx";

export interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "value" | "onChange"> {
  value: string;
  onChange: (value: string) => void;
  invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { value, onChange, invalid = false, className, ...props },
  ref,
) {
  return (
    <input
      ref={ref}
      className={cx("input input-sm", invalid && "input-error is-invalid", className)}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      aria-invalid={invalid || undefined}
      {...props}
    />
  );
});
